/*
  Project: cleantle
  Author: Daniel Kozina
 */

import Swiper, { Navigation, Pagination, Autoplay, Thumbs } from 'swiper';

import header from './modules/header';
import blockHero from './modules/block-hero';
import blockReviews from './modules/block-reviews';
import blockSocialSlide from './modules/block-social';
import blockProductsSlide from './modules/block-products-slide';
import blockHeroProduct from './modules/block-hero-product';
import customSelect from './modules/custom-select';
import blockSpecification from './modules/block-specification';
import blockVideo from './modules/block-video';
import blockOtherProducts from './modules/block-other-products';
import seeMoreText from './modules/see-more-text';
import blockShopList from './modules/block-shop-list';
import filter from './modules/filter';
// import blockNewsletter from './modules/block-newsletter';
import productSearch from './modules/productSearch';

document.addEventListener('DOMContentLoaded', () => {
	header();
	blockHero(Swiper, Navigation, Pagination, Autoplay);
	blockReviews(Swiper, Navigation, Pagination, Autoplay);
	blockSocialSlide(Swiper, Navigation, Pagination, Autoplay);
	blockProductsSlide(Swiper, Navigation, Pagination, Autoplay);
	blockHeroProduct(Swiper, Navigation, Pagination, Autoplay, Thumbs);
	customSelect();
	blockSpecification(Swiper, Navigation, Pagination, Autoplay);
	blockVideo();
	blockOtherProducts(Swiper, Navigation, Pagination, Autoplay);
	seeMoreText();
	blockShopList();
	filter();
	// blockNewsletter();
	productSearch();
});
